<template>
	<div>
		<!-- <div @click="displayNotification()">Notification</div> -->
		<!-- <div class="notification-dropdown">
			<div class="heading">
				<h6>Notificaciones</h6>
				
			</div>
			<div class="notification-list">
				<ul v-infinite-scroll="load" infinite-scroll-disabled="loading" infinite-scroll-distance="10" infinite-scroll-immediate-check="fase">
					<li class="notification-item" v-for="notification in notifications" :key="notification.id" :class="{ unread: !notification.readed }" @click="setNotificationReaded(notification)">
						<div class="user-content">
							<p class="user-info">
								<span class="name">{{ notification.subject }} </span> <br />{{ notification.message }}
							</p>
						</div>
						<p class="time text-right">{{ notification.createdAt | moment("from") }}</p>
					</li>
				</ul>
				<Loader :show="loading" type="inline" />
			</div>
		</div> -->
	</div>
</template>

<script>
import gql from 'graphql-tag'
import { mapGetters } from 'vuex'
// import infiniteScroll from "vue-infinite-scroll"
// import Loader from "../../components/layout/Loader"

export default {
	name: 'NotificationsDropdown',
	// directives: { infiniteScroll, Loader },
	data() {
		return {
			notifications: [],
			unreadCounter: 0,
			loading: false,
			take: 6,
			skip: 0,
			hasMore: true,
		}
	},

	computed: {
		...mapGetters(['loggedUser']),
	},

	beforeMount() {
		// this.load()
	},

	methods: {
		load() {
			if (!this.loading && this.hasMore) {
				this.loading = true
				this.$apollo
					.query({
						query: gql`
							query($take: Int, $skip: Int) {
								userNotifications(take: $take, skip: $skip) {
									data {
										id
										subject
										message
										createdAt
										readed
									}
									pageInfo {
										totalItems
									}
								}
								userNotificationsCountUnread
							}
						`,
						variables: {
							take: this.take,
							skip: this.skip,
						},
						fetchPolicy: 'no-cache',
					})
					.then(({ data }) => {
						data.userNotifications.data.forEach((notification) => {
							this.notifications.push(notification)
							this.skip++
						})
						this.unreadCounter = data.userNotificationsCountUnread
						this.loading = false
						this.$emit('unreadCounter', this.unreadCounter)

						if (data.userNotifications.pageInfo.totalItems <= this.notifications.length) {
							this.hasMore = false
						}
					})
			}
		},

		setNotificationReaded(notification) {
			this.$apollo
				.mutate({
					mutation: gql`
						mutation($id: ID!) {
							userNotificationReaded(id: $id) {
								id
								subject
								message
								createdAt
								readed
							}
						}
					`,
					variables: {
						id: notification.id,
					},
				})
				.then(({ data }) => {
					this.$nextTick(() => {
						notification = data.userNotificationReaded
						this.load()
						// console.log(index)
						// console.log(this.notifications[index])
					})
				})
				.catch((error) => {
					this.parseGQLErrors(error)
				})
		},

		notificationReceived(notification) {
			console.log(notification)
			this.$notification.show(notification.subject, { body: notification.message }, {})
			this.displayNotification()
		},

		displayNotification() {
			console.log('displayNotification')
			Notification.requestPermission(function(status) {
				console.log('Notification permission status:', status)
			})
			if (Notification.permission === 'granted') {
				navigator.serviceWorker.getRegistration().then(function(reg) {
					if (reg == undefined) {
						console.log('only works online')
						return
					}
					var options = {
						body: 'First notification!',
						icon: '@/assets/img/damage-total.png',
						vibrate: [100, 50, 100],
						data: {
							dateOfArrival: Date.now(),
							primaryKey: 1,
						},
						actions: [
							{
								action: 'explore',
								title: 'Go to the site',
								icon: '@/assets/img/damage-riven.png',
							},
							{
								action: 'close',
								title: 'Close the notification',
								icon: '@/assets/img/damage-dent.png',
							},
						],
					}
					reg.showNotification('Your Message Here!', options)
				})
			}
		},
	},

	// https://hasura.io/learn/graphql/vue/subscriptions/3-create-subscription/

	// apollo: {
	// 	$subscribe: {
	// 		userNotificationCreated: {
	// 			query: gql`
	// 				subscription($userId: String!) {
	// 					userNotificationCreated(userId: $userId) {
	// 						id
	// 						subject
	// 						message
	// 					}
	// 				}
	// 			`,
	// 			variables() {
	// 				return {
	// 					userId: this.loggedUser.id
	// 				}
	// 			},
	// 			result({ data }) {
	// 				if (data.userNotificationCreated.id) {
	// 					this.notificationReceived(data.userNotificationCreated)
	// 				}
	// 			}
	// 		}
	// 	}
	// }
}
</script>

<style scoped lang="scss">
.notification {
	position: absolute;
}

.notification-dropdown {
	line-height: 1.5;
	color: #27303d;
	width: 20rem;
	background: #fff;
}

.notification-list {
	max-height: 290px;
	overflow: auto;
}
.notification-dropdown ul {
	padding: 0px;
}

.notification-item {
	display: flex;
	border-left: 2px solid #fff;
	align-items: flex-start;
	padding: 0.5rem 18px;
	cursor: pointer;
}

.notification-item:hover {
	color: #16181b;
	text-decoration: none;
	background-color: #f8f9fa;
}
.notification-item.active,
.notification-item:active {
	color: #fff;
	background-color: #143155;
}

.notification-item.unread {
	border-left: 2px solid #006cb8;
}

.notification-item > div:first-child {
	flex-grow: 1;
}

.heading {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0.5rem 1rem;
	border-bottom: 0.01rem solid #eee;
}

p {
	&.user-info {
		margin: 0.15rem 0 0;
	}
	&.time {
		font-size: 12px;
		margin: 0;
		color: #9da4ae;
	}
}

span.name {
	font-weight: 500;
}
</style>
